var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrueMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8139 20.0002L10.7021 20.8081L9.08567 19.3151L6.79994 19.3149L5.925 17.3642L3.81334 16.5559L3.81311 14.4444L2.19702 12.9511L3.07151 11.0002L2.19702 9.04933L3.81311 7.55608L3.81334 5.44453L5.925 4.63627L6.79994 2.68553L9.08567 2.68531L10.7021 1.19238L12.8139 2.00023L14.9258 1.19238L16.5423 2.68531L18.8279 2.68553L19.7029 4.63627L21.8145 5.44453L21.8147 7.55608L23.4309 9.04933L22.5564 11.0002L23.4309 12.9511L21.8147 14.4444L21.8145 16.5559L19.7029 17.3642L18.8279 19.3149L16.5423 19.3151L14.9258 20.8081L12.8139 20.0002Z",
    fill: "#F0F0F5",
    stroke: "#2D2D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4423 11.2123C8.16418 10.9584 7.71326 10.9584 7.43515 11.2123C7.15703 11.4662 7.15703 11.8778 7.43515 12.1317L10.7586 15.1658C11.0367 15.4197 11.4876 15.4197 11.7657 15.1658L18.4127 9.09767C18.6907 8.84377 18.6907 8.43212 18.4127 8.17822C18.1345 7.92432 17.6836 7.92432 17.4055 8.17822L11.2622 13.7866L8.4423 11.2123Z",
    fill: "#2D2D32",
    stroke: "#2D2D32",
    strokeWidth: 0.506465
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrueMark);
export default __webpack_public_path__ + "static/media/true_mark.b08ff2a560cf8d19a088712a6d02c920.svg";
export { ForwardRef as ReactComponent };